import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { Button, Input, VStack, Heading, Text } from "@chakra-ui/react";
import styled from "styled-components";
import { colors } from "../colors";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const LoginBox = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 400px;
`;

export const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    const success = await login(password);
    setIsLoading(false);

    if (success) {
      navigate("/admin/builder");
    } else {
      setError("Invalid password");
      setPassword("");
    }
  };

  return (
    <Container>
      <LoginBox>
        <VStack spacing={6} as="form" onSubmit={handleSubmit}>
          <Heading size="xl" color={colors.black}>
            Admin Login
          </Heading>
          <Text color="gray.600">Enter admin password to continue</Text>

          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            size="lg"
            focusBorderColor={colors.gold}
            isInvalid={!!error}
            autoFocus
          />

          {error && (
            <Text color="red.500" fontSize="sm">
              {error}
            </Text>
          )}

          <Button
            type="submit"
            size="lg"
            width="100%"
            bg={colors.gold}
            color="white"
            isLoading={isLoading}
            _hover={{ bg: colors.gold + "dd" }}
          >
            Login
          </Button>
        </VStack>
      </LoginBox>
    </Container>
  );
};
